import { Flex, Text } from '@chakra-ui/react';
import { Link } from '@morressier/alembic';
import ReactMarkdown from 'react-markdown';

interface Props {
  markdownString: string;
}

export const CopyrightAndPublicationAgreement: React.FC<Props> = ({
  markdownString
}) => {
  return (
    <Flex flexDirection="column" padding={4}>
      <ReactMarkdown
        components={{
          h1: ({ ...props }) => (
            <Text textStyle="headingGroup" mt={1} mb={4} {...props} />
          ),
          p: ({ ...props }) => <Text textStyle="textBody" mb={3} {...props} />,
          a: ({ children, ...props }) => {
            if (props.href === '#') {
              return (
                <Link
                  variant="primary"
                  href="#"
                  isExternal
                  {...props}
                  onClick={e => e.preventDefault()}
                >
                  {children}
                </Link>
              );
            }
            return (
              <Link variant="primary" href={props.href} isExternal {...props}>
                {children}
              </Link>
            );
          }
        }}
      >
        {markdownString}
      </ReactMarkdown>
    </Flex>
  );
};
